import React from 'react';
import { string } from 'yup';
import { IntegrationGoogleDrivePanel } from './google-drive-panel';
import { IntegrationGongPanel } from './gong-panel';
import { IntegrationDropboxPanel } from './dropbox-panel';

const SUPPORTED_INTEGRATION_TYPES = ['google-drive', 'gong', 'dropbox'];

export const IntegrationConnectWithIntegrationSection = ({
  integrationType,
  onNewUrl,
  onNewVideoFromExternalUrl,
  setBlockToLoading,
}: {
  integrationType: string
  onNewUrl: (url: string) => void;
  onNewVideoFromExternalUrl: (url: string, metaData: any, importParams: any) => void;
  setBlockToLoading: () => void;
}) => {
  if (integrationType === 'google-drive') {
    return <IntegrationGoogleDrivePanel onNewUrl={onNewUrl} />;
  } else if (integrationType === 'gong') {
    return <IntegrationGongPanel onNewVideo={onNewVideoFromExternalUrl} />
  } else if (integrationType === 'dropbox') {
    return <IntegrationDropboxPanel onNewUrl={onNewUrl} setBlockToLoading={setBlockToLoading} />
  }

  return null;
}